import React from 'react';
import {
  Box,
  useTheme,
} from '@mui/material';

interface DayIndicatorsProps {
  courseDates: string[];
  assignedDates: string[];
}

const DayIndicators: React.FC<DayIndicatorsProps> = ({ courseDates, assignedDates }) => {
  const theme = useTheme();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const isAssigned = (date: string) => {
    return assignedDates.includes(date);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {courseDates.map((date, index) => {
        const assigned = isAssigned(date);
        const formattedDate = formatDate(date);
        
        return (
          <Box
            key={date}
            sx={{
              minWidth: { xs: 60, sm: 70 },
              height: { xs: 32, sm: 40 },
              borderRadius: { xs: 16, sm: 20 },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: assigned 
                ? theme.palette.success.main 
                : theme.palette.grey[300],
              color: assigned 
                ? 'white'
                : theme.palette.text.secondary,
              fontWeight: 'bold',
              fontSize: { xs: '10px', sm: '12px' },
              transition: 'all 0.2s ease-in-out',
              px: { xs: 1.5, sm: 2 },
            }}
          >
            {formattedDate}
          </Box>
        );
      })}
    </Box>
  );
};

export default DayIndicators;
